import React from 'react';

import EditorQuestionText from '@/modules/corporate/modules/questions/fields/components/Editor/EditorQuestionText';
import { QuestionEditorProps } from '@/modules/corporate/modules/questions/fields/types';

import QuestionEditorContainer from '../QuestionEditorContainer';

function Editor(props: QuestionEditorProps & { EditorOptionsList: React.FC<QuestionEditorProps> }) {
  const { EditorOptionsList } = props;

  return (
    <QuestionEditorContainer {...props}>
      <EditorQuestionText className="mt-8" {...props} />
      <EditorOptionsList className="mt-32" {...props} />
    </QuestionEditorContainer>
  );
}

export default Editor;
